import * as types from '../constants/ActionTypes.js'

const initBarcodeState = {
    barcodePrefix: null
};

export const barcodeReducer = function init(state = initBarcodeState, action) {
    switch (action.type) {
        case types.CLEAR_STATE:
            return initBarcodeState;
        case types.SET_BARCODE_PREFIX:
            return {
                ...state, 
                barcodePrefix: action.barcodePrefix
            };
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// src/reducers/barcode.js